import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { environment } from 'src/environments/environment';
import { DeviceInfosService } from './services/device-infos.service';
import { FcmService } from './services/fcm.service';
import { ThemeService } from './services/theme.service';
// import { SplashScreen } from '@capacitor/splash-screen';

// import { SafeArea } from "capacitor-plugin-safe-area";
// SafeArea.getSafeAreaInsets().then((data) => {
//   const { insets } = data;
//   document.body.style.setProperty("--ion-safe-area-top", `${insets.top}px`);
//   document.body.style.setProperty(
//     "--ion-safe-area-right",
//     `${insets.right}px`
//   );
//   document.body.style.setProperty(
//     "--ion-safe-area-bottom",
//     `${insets.bottom}px`
//   );
//   document.body.style.setProperty(
//     "--ion-safe-area-left",
//     `${insets.left}px`
//   );
// });

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})


export class AppComponent implements OnInit {

  constructor(
    private authService: AuthenticationService,
    private deviceInfos: DeviceInfosService,
    private fcm: FcmService,
    private themeService: ThemeService
  ) { 
    
  }

  async ngOnInit(){
    // console.log('AppComponent initialized');

    // await SplashScreen.hide();
    if (environment.targetDevice=='ios' || environment.targetDevice=='android'){
      await this.fcm.initPush();
    }
    
    this.deviceInfos.load();
  }
}
